import { Container, styled, TextField } from "@mui/material";

export const DateRangeRoot = styled(Container)(() => ({
	display: "flex",
	flexDirection: "row",
	maxWidth: "none",
	paddingLeft: "0 !important",
	paddingRight: "0px !important",
	gap: "8px",
}));

export const DateTextField = styled(TextField)(({ theme }) => ({
	width: "50%",

	"& .MuiInputBase-root": {
		height: 33,
		fontSize: 13,
		color: theme.palette.secondary.main,
		paddingRight: 20,
	},

	"& .MuiInputBase-input": {
		paddingRight: 0,
	},
	"& .MuiInputLabel-root": {
		fontSize: 13,
	},
	'& .MuiInputLabel-root[data-shrink="false"]': {
		top: -8,
	},
}));

export const ClearButton = styled("button")({
	position: "absolute",
	right: "4px",
	top: "50%",
	transform: "translateY(-50%)",
	background: "transparent",
	border: "none",
	cursor: "pointer",
	color: "rgba(0, 0, 0, 0.54)",
	padding: "4px",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	"&:hover": {
		color: "rgba(0, 0, 0, 0.87)",
		backgroundColor: "rgba(0, 0, 0, 0.04)",
		borderRadius: "50%",
	},
});
